import { NgxRolesService } from 'ngx-permissions';
import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../../services/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient, HttpParams } from '@angular/common/http';
import { PNotifyService } from '../../../services/pnotify.service';
import { IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts } from 'angular-2-dropdown-multiselect';
import { Select2OptionData } from 'ng2-select2';

declare var google: any;
declare var $: any;

@Component({
  selector: 'app-subscription-zones-distribution',
  templateUrl: './subscription-zones-distribution.component.html',
  styleUrls: ['./subscription-zones-distribution.component.css']
})
export class SubscriptionZonesDistributionComponent implements OnInit {

  // ─── Core Data ─────────────────────────────────────────────────
  school: any = {};
  filter = { clientId: '', schoolId: '', busIds: [] };
  adminStatus = false;
  isResponsible = false;
  loadData = false;
  pnotify: any;

  // ─── Filter Selects ───────────────────────────────────────────
  clients: any[] = [];
  clientsData: Array<Select2OptionData> = [];
  schools: any[] = [];
  schoolsData: Array<Select2OptionData> = [];
  buses: any[] = [];
  multiSelectBus: IMultiSelectOption[] = [];
  optionsModelBus: number[] = [];
  multiSelectSettings: IMultiSelectSettings = {
    enableSearch: true,
    checkedStyle: 'fontawesome',
    showCheckAll: true,
    showUncheckAll: true,
    buttonClasses: 'btn btn-default btn-block btn-position',
    dynamicTitleMaxItems: 0,
    displayAllSelectedText: true,
    containerClasses: 'dropdown-block',
  };
  multiSelectTexts: IMultiSelectTexts = {
    checkAll: 'Tout sélectionner',
    uncheckAll: 'Tout déselectionner',
    checked: 'élément sélectionné',
    checkedPlural: 'sélectionnés',
    searchPlaceholder: 'Trouver',
    searchEmptyResult: 'Aucun résultat',
    defaultTitle: 'Sélectionner',
    allSelected: 'Tous sélectionnés',
  };
  filterReady = false;
  onLoadFilter = true;
  passengersData: Array<Select2OptionData> = [];
  parentSelectedId: any;

  // ─── Inscription Type Filter ──────────────────────────────────
  multiSelectInscriptionType: IMultiSelectOption[] = [
    { id: 'new', name: 'Nouveau' },
    { id: 'renew', name: 'Renouvellement' },
    { id: '-', name: 'Année en cours' },
  ];
  optionsModelInscriptionType: string[] = ['-'];
  inscriptionTypeInitialized = false;

  // ─── Zone Filter ──────────────────────────────────────────────
  multiSelectZone: IMultiSelectOption[] = [];
  optionsModelZone: number[] = [];

  // ─── Map ───────────────────────────────────────────────────────
  map: any;
  markerBounds: any;
  schoolMarker: any;
  parentMarkers: any[] = [];
  centroidMarkers: any[] = [];
  centroidMapClickListener: any;
  centroidMode = false;
  initialBoundsFitted = false;

  // ─── Zone & Assignment State (local working copy) ──────────────
  zones: any[] = [];           // local zone list [{zoneId, zoneName, busId, busName, busColor, capacity, centroidPos}]
  passengers: any[] = [];      // local passenger list [{id, name, lat, lng, count, busId, zoneId, zoneId_original, busId_original}]
  passengersWithoutPositionCount = 0;
  passengersWithoutPositionChildrenCount = 0;
  hasLocalChanges = false;

  // ─── Action Mode ───────────────────────────────────────────────
  actionMode: 'none' | 'recreate' | 'adapt' | 'manual' = 'none';
  automationLoading = false;
  automationResult: any = null;
  manualAssignZoneId: number = null; // null = deaffect mode
  manualDeaffectMode = false;
  showHelpModal = false;

  // ─── Confirmation Dialog ────────────────────────────────────────
  showConfirmModal = false;
  confirmTitle = '';
  confirmMessage = '';
  confirmIcon = '';
  confirmBtnText = '';
  confirmBtnClass = '';
  confirmAction: () => void = null;

  // ─── Shape definitions by zone LEVEL within a bus ─────────────────
  // Level 0 (1st zone of each bus) = circle
  // Level 1 (2nd zone of each bus) = pentagon
  // Level 2+ = forward arrow, backward arrow...
  // Unassigned passengers = square (same as "assistant" in assignments view)
  readonly ZONE_LEVEL_SHAPES = [
    google.maps.SymbolPath.CIRCLE,                    // ● level 0 (zone 1)
    'M 0,-1.4 1.3,-0.4 0.8,1.1 -0.8,1.1 -1.3,-0.4 z', // ⬟ level 1 (zone 2)
    google.maps.SymbolPath.FORWARD_CLOSED_ARROW,      // ▶ level 2
    google.maps.SymbolPath.BACKWARD_CLOSED_ARROW,     // ◀ level 3
  ];
  readonly UNASSIGNED_SHAPE = 'M -1,-1 1,-1 1,1 -1,1 z'; // ■ square for unassigned
  readonly ASSISTANT_SHAPE = 'M 0,-1.5 0.35,-0.47 1.43,-0.46 0.54,0.18 0.88,1.24 0,0.6 -0.88,1.24 -0.54,0.18 -1.43,-0.46 -0.35,-0.47 z'; // ★ star for assistants

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private http: HttpClient,
    private roleService: NgxRolesService,
    pnotifyService: PNotifyService
  ) {
    this.pnotify = pnotifyService.getPNotify();
    this.adminStatus = !!this.roleService.getRole('ROLE_SUPER_CLIENT') || !!this.roleService.getRole('ROLE_ADMIN');
    if (this.roleService.getRole('ROLE_RESPONSIBLE')) {
      this.isResponsible = true;
    }
    this.initClientSelect();
  }

  ngOnInit() {
  }

  // ═══════════════════════════════════════════════════════════════
  // 1. FILTER & DATA LOADING
  // ═══════════════════════════════════════════════════════════════

  initClientSelect() {
    if (this.roleService.getRole('ROLE_CLIENT') || this.roleService.getRole('ROLE_SUPER_CLIENT')) {
      const client = this.authService.getUser();
      this.clients = [{ id: client.id, name: client.name }];
      this.filter.clientId = client.id;
      this.initSchoolSelect();
    } else if (this.roleService.getRole('ROLE_RESPONSIBLE')) {
      const client = this.authService.getUser().School.Client;
      this.clients = [{ id: client.id, name: client.name }];
      this.filter.clientId = client.id;
      this.initSchoolSelect();
    } else {
      this.http.get<any[]>('/api/client/lookup').subscribe((clients: any[]) => {
        this.clients = clients;
        this.clientsData = this.clients.map((c) => ({ id: c.id, text: c.name }));
      });
    }
  }

  clientChanged(e: any) {
    this.filter.clientId = e.value;
    this.filter.schoolId = '';
    this.filter.busIds = [];
    this.optionsModelBus = [];
    this.multiSelectBus = [];
    this.filterReady = false;
    this.initSchoolSelect();
  }

  initSchoolSelect() {
    this.filter.schoolId = '';
    const params = new HttpParams({ fromObject: { clientId: this.filter.clientId + '' } });
    this.http.get<any[]>('/api/school/lookup', { params }).subscribe((schools: any[]) => {
      this.schools = schools;
      this.schoolsData = this.schools.map((s) => {
        if (this.isResponsible) {
          return { id: s.id, text: s.name, selected: (this.authService.getUser().School.id === s.id) };
        }
        return { id: s.id, text: s.name };
      });
    });
  }

  schoolChanged(e: any) {
    this.filter.schoolId = e.value;
    this.filter.busIds = [];
    this.optionsModelBus = [];
    this.multiSelectBus = [];
    this.optionsModelZone = [];
    this.multiSelectZone = [];
    this.filterReady = false;
    this.initBusSelect();
  }

  initBusSelect() {
    const params = new HttpParams({ fromObject: { clientId: this.filter.clientId + '', schoolId: this.filter.schoolId + '', all: 'true' } });
    this.http.get<any[]>('/api/bus/lookup', { params }).subscribe((buses: any[]) => {
      this.buses = buses;
      this.multiSelectBus = this.buses;
      this.optionsModelBus = this.buses.map(b => b.id);
      this.filter.busIds = [...this.optionsModelBus];
      this.filterReady = true;
      this.fillPassenger();
    });
  }

  fillPassenger() {
    if (!this.filter.schoolId) return;
    const params = new HttpParams({
      fromObject: {
        clientId: this.filter.clientId + '',
        schoolId: this.filter.schoolId + '',
        busIds: JSON.stringify(this.optionsModelBus),
        isPositionValide: 'true',
        isActive: 'true',
      }
    });
    this.http.get('/api/passenger/lookup2', { params }).subscribe((passengers: any) => {
      this.passengersData = [
        { id: '', text: '-- Tous les parents --' },
        ...(passengers.rows || []).map((p) => ({ id: p.id, text: p.lastname }))
      ];
      this.parentSelectedId = null;
      if (this.onLoadFilter) {
        this.onFilter();
        this.onLoadFilter = false;
      }
    });
  }

  parentsChanged(e: any) {
    this.parentSelectedId = e.value || null;
  }

  onBusChange() {
    this.filter.busIds = [...this.optionsModelBus];
  }

  onFilter() {
    if (!this.filter.schoolId || !this.filter.clientId) return;
    this.loadSchoolData();
  }

  loadSchoolData() {
    this.loadData = true;
    this.initialBoundsFitted = false;
    const params = new HttpParams({ fromObject: { clientId: this.filter.clientId + '' } });

    this.http.get('/api/subscription/getSchoolAgendaZonesPassengers', { params })
      .subscribe((school: any) => {
        this.school = school;
        this.passengersWithoutPositionCount = school.passengersWithoutPositionCount || 0;
        this.passengersWithoutPositionChildrenCount = school.passengersWithoutPositionChildrenCount || 0;
        // Module always active: default inscription type filter to "Année en cours" ('-')
        if (!this.inscriptionTypeInitialized) {
          this.inscriptionTypeInitialized = true;
          this.optionsModelInscriptionType = ['-'];
        }
        this.buildLocalData();
        this.initMap();
        this.loadData = false;
      }, () => {
        this.loadData = false;
      });
  }

  /**
   * Build local zones and passengers arrays from school data.
   * Rule: if passenger has busId but no zoneOfServiceId, default to first zone of that bus.
   * Compute zoneLevel (0-based order within same bus) for shape assignment.
   */
  buildLocalData() {
    // Build zones from school.zonesOfService, filtered by selected buses
    const selectedBusIds = this.filter.busIds && this.filter.busIds.length > 0 ? this.filter.busIds : null;
    const schoolZones = (this.school.zonesOfService || []).filter(z => {
      if (!selectedBusIds) return true;
      const busId = z.Bus ? z.Bus.id : z.busId;
      return selectedBusIds.indexOf(busId) !== -1;
    });
    const busZoneCounters: { [busId: number]: number } = {};

    this.zones = schoolZones.map((z, idx) => {
      let centroidPos = null;
      if (z.centroid && z.centroid.indexOf(',') > 0) {
        const parts = z.centroid.split(',');
        centroidPos = { lat: parseFloat(parts[0]), lng: parseFloat(parts[1]) };
      }
      const busId = z.Bus ? z.Bus.id : z.busId;
      // Compute zone level within the bus (0, 1, 2...)
      if (!busZoneCounters[busId]) busZoneCounters[busId] = 0;
      const zoneLevel = busZoneCounters[busId]++;

      return {
        zoneId: z.id,
        zoneName: z.name || (z.Bus ? z.Bus.name : 'Zone ' + (idx + 1)),
        busId: busId,
        busName: z.Bus ? z.Bus.name : '',
        driverName: z.Bus ? (z.Bus.driverName || '-') : '-',
        busColor: z.Bus ? (z.Bus.colorLineBus || '#337ab7') : '#337ab7',
        capacity: z.Bus ? (z.Bus.maxLoad > 0 ? z.Bus.maxLoad : 50) : 50,
        centroidPos: centroidPos,
        centroidPos_original: centroidPos ? { lat: centroidPos.lat, lng: centroidPos.lng } : null,
        zoneLevel: zoneLevel // 0=first zone of bus, 1=second, etc.
      };
    });

    // Populate zone filter (rebuild to reflect current bus selection)
    this.multiSelectZone = this.zones.map(z => ({ id: z.zoneId, name: z.zoneName + ' (' + z.busName + ')' }));
    const zoneIds = this.zones.map(z => z.zoneId);
    // Keep only previously selected zones that still exist
    this.optionsModelZone = this.optionsModelZone.filter(id => zoneIds.indexOf(id) !== -1);
    // If nothing selected (first load or all removed), select all
    if (this.optionsModelZone.length === 0) {
      this.optionsModelZone = [...zoneIds];
    }

    // Build passengers from school.Passengers, filtered by selected buses, zones & inscription type
    const schoolPassengers = this.school.Passengers || [];
    const selectedInscriptionTypes = this.optionsModelInscriptionType || [];
    this.passengers = schoolPassengers
      .filter(p => {
        if (!p.lat || !p.lng || p.lat === '0' || p.lng === '0') return false;
        if (selectedBusIds) {
          if (p.busId && selectedBusIds.indexOf(p.busId) === -1) return false;
        }
        if (selectedInscriptionTypes.length > 0) {
          const pType = p.inscriptionType || '-';
          if (selectedInscriptionTypes.indexOf(pType) === -1) return false;
        }
        if (this.optionsModelZone.length > 0 && this.optionsModelZone.length < this.zones.length) {
          const pZoneId = p.zoneOfServiceId || (p.ZoneOfService ? p.ZoneOfService.id : null);
          if (pZoneId && this.optionsModelZone.indexOf(pZoneId) === -1) return false;
        }
        return true;
      })
      .map(p => {
        let zoneId = p.zoneOfServiceId || (p.ZoneOfService ? p.ZoneOfService.id : null);

        // Default: if passenger has bus but no zone, assign to first zone of that bus
        if (!zoneId && p.busId) {
          const defaultZone = this.zones.find(z => z.busId === p.busId);
          if (defaultZone) zoneId = defaultZone.zoneId;
        }

        return {
          id: p.id,
          name: (p.lastname + ' ' + (p.firstnames || '')).trim(),
          firstname: p.firstnames || '',
          lastname: p.lastname || '',
          lat: parseFloat(p.lat),
          lng: parseFloat(p.lng),
          count: (p.count && p.count > 0) ? p.count : 1,
          busId: p.busId || null,
          zoneId: zoneId,
          isAssistant: !!p.isAssistant,
          inscriptionType: p.inscriptionType || '-',
          inscriptionDate: p.inscriptionDate || '',
          subscription: p.subscription || '',
          // Store originals for revert
          zoneId_original: zoneId,
          busId_original: p.busId || null
        };
      });

    this.hasLocalChanges = false;
    this.actionMode = 'none';
    this.automationResult = null;
  }

  // ═══════════════════════════════════════════════════════════════
  // 2. MAP INITIALIZATION & RENDERING
  // ═══════════════════════════════════════════════════════════════

  initMap() {
    this.stopMapClickForCentroids();

    const pos = (this.school && this.school.lat && this.school.lng)
      ? { lat: Number(this.school.lat), lng: Number(this.school.lng) }
      : { lat: 31.585832, lng: -6.183891 };

    this.markerBounds = new google.maps.LatLngBounds();

    this.map = new google.maps.Map(document.getElementById('zone-map'), {
      center: pos,
      zoom: 12,
      gestureHandling: 'cooperative',
      scrollwheel: false,
      mapTypeControl: true,
      streetViewControl: false,
    });

    // School marker
    this.schoolMarker = new google.maps.Marker({
      position: pos,
      map: this.map,
      icon: 'assets/images/markers/school.png',
      draggable: false,
      zIndex: 300,
    });
    const schoolInfowindow = new google.maps.InfoWindow({
      content: '<b>École : </b>' + (this.school.name || '')
    });
    this.schoolMarker.addListener('mouseover', () => schoolInfowindow.open(this.map, this.schoolMarker));
    this.schoolMarker.addListener('mouseout', () => schoolInfowindow.close());
    this.markerBounds.extend(pos);

    this.renderParentMarkers();
    this.renderCentroidMarkers();

    if (this.centroidMode) {
      this.startMapClickForCentroids();
    }
  }

  /**
   * Render parent markers on map.
   * Shape = zone level within bus (circle=level0, pentagon=level1, etc.)
   * Color = bus color
   * Unassigned passengers = square, grey
   */
  renderParentMarkers() {
    // Clear existing
    for (const m of this.parentMarkers) { m.setMap(null); }
    this.parentMarkers = [];
    if (!this.map || this.passengers.length === 0) return;

    // Build zone lookup by zoneId
    const zoneLookup: { [zoneId: number]: any } = {};
    for (const z of this.zones) {
      zoneLookup[z.zoneId] = z;
    }

    const infowindow = new google.maps.InfoWindow();
    const _this = this;
    const offsets = this.buildSpiderfyOffsets(this.passengers);

    for (let i = 0; i < this.passengers.length; i++) {
      const p = this.passengers[i];
      const zone = p.zoneId ? zoneLookup[p.zoneId] : null;
      let color: string;
      let shape: any;
      let strokeColor: string;

      if (p.isAssistant) {
        // Assistant: star icon with zone color or grey
        color = zone ? (zone.busColor || '#337ab7') : '#f39c12';
        shape = this.ASSISTANT_SHAPE;
        strokeColor = '#fff';
      } else if (zone) {
        // Assigned passenger: color = bus color, shape = zone level
        color = zone.busColor || '#337ab7';
        shape = this.ZONE_LEVEL_SHAPES[zone.zoneLevel % this.ZONE_LEVEL_SHAPES.length];
        strokeColor = '#fff';
      } else {
        // Unassigned passenger: square, grey
        color = '#999';
        shape = this.UNASSIGNED_SHAPE;
        strokeColor = '#999';
      }

      const realPos = new google.maps.LatLng(p.lat, p.lng);
      const off = offsets[i];
      const pos = off ? new google.maps.LatLng(off.lat, off.lng) : realPos;
      const marker = new google.maps.Marker({
        position: pos,
        map: this.map,
        icon: {
          path: shape,
          scale: 8,
          fillColor: color,
          fillOpacity: 1,
          strokeWeight: 2,
          strokeColor: strokeColor
        },
        zIndex: 100
      });

      // Store passenger reference on marker for manual mode
      (marker as any)._passenger = p;

      const buildPopupContent = (passenger: any) => {
        const typeLabels: { [key: string]: string } = { 'new': 'Nouveau', 'renew': 'Renouvellement', '-': 'Année en cours' };
        const typeLabel = typeLabels[passenger.inscriptionType] || passenger.inscriptionType;
        const typeBadge = passenger.inscriptionType === 'new' ? 'badge-new' : (passenger.inscriptionType === 'renew' ? 'badge-renew' : 'badge-ongoing');
        const dateFormatted = passenger.inscriptionDate ? passenger.inscriptionDate : '-';
        const sub = passenger.subscription || '-';
        const currentZone = passenger.zoneId ? zoneLookup[passenger.zoneId] : null;
        const zoneInfo = currentZone ? `<div class="pw-row"><span class="pw-label">Zone</span><span class="pw-value" style="color:${currentZone.busColor || '#337ab7'}">${currentZone.zoneName} (${currentZone.busName})</span></div>` : '<div class="pw-row"><span class="pw-label">Zone</span><span class="pw-value pw-muted">Non affecté</span></div>';
        const assistantBadge = passenger.isAssistant ? '<span class="pw-badge pw-badge-assistant">★ Assistant</span>' : '';

        return `<div class="passenger-popup">
          <div class="pw-header">
            <span class="pw-name">${passenger.firstname} ${passenger.lastname}</span>
            ${assistantBadge}
          </div>
          <div class="pw-body">
            <div class="pw-row"><span class="pw-label">Passagers</span><span class="pw-value">${passenger.count}</span></div>
            <div class="pw-row"><span class="pw-label">Type</span><span class="pw-value"><span class="pw-badge ${typeBadge}">${typeLabel}</span></span></div>
            <div class="pw-row"><span class="pw-label">Date inscription</span><span class="pw-value">${dateFormatted}</span></div>
            <div class="pw-row"><span class="pw-label">Abonnement</span><span class="pw-value">${sub}</span></div>
            ${zoneInfo}
            <div class="pw-row"><span class="pw-label">GPS</span><span class="pw-value pw-mono">${passenger.lat.toFixed(5)}, ${passenger.lng.toFixed(5)}</span></div>
          </div>
        </div>`;
      };

      marker.addListener('mouseover', function() {
        infowindow.setContent(buildPopupContent(p));
        infowindow.open(_this.map, marker);
      });
      marker.addListener('mouseout', function() {
        // Only close if not pinned by click (pin only in non-manual mode)
        if (!(marker as any)._popupPinned) {
          infowindow.close();
        }
      });
      marker.addListener('click', function() {
        if (_this.actionMode === 'manual') {
          _this.handleManualAssignment(p, marker);
        } else {
          // Toggle pin on click
          if ((marker as any)._popupPinned) {
            (marker as any)._popupPinned = false;
            infowindow.close();
          } else {
            // Clear any previously pinned marker
            for (const m of _this.parentMarkers) {
              (m as any)._popupPinned = false;
            }
            (marker as any)._popupPinned = true;
            infowindow.setContent(buildPopupContent(p));
            infowindow.open(_this.map, marker);
          }
        }
      });

      this.parentMarkers.push(marker);
      this.markerBounds.extend(pos);

      // If this passenger is selected in parent filter, zoom and show popup
      if (this.parentSelectedId && (this.parentSelectedId + '') === (p.id + '')) {
        infowindow.setContent(buildPopupContent(p));
        infowindow.open(this.map, marker);
        (marker as any)._popupPinned = true;
        this.map.setCenter(pos);
        this.map.setZoom(15);
      }
    }

    if (this.passengers.length > 0 && !this.initialBoundsFitted && !this.parentSelectedId) {
      this.map.fitBounds(this.markerBounds);
      this.initialBoundsFitted = true;
    }
  }

  /**
   * Compute small circular offsets for items sharing the exact same position,
   * so overlapping markers stay individually visible/clickable.
   * Returns an array aligned with `items` (null = no offset needed).
   */
  buildSpiderfyOffsets(items: any[]): ({ lat: number, lng: number } | null)[] {
    const offsets: ({ lat: number, lng: number } | null)[] = items.map(() => null);
    const groups: { [key: string]: number[] } = {};
    items.forEach((it, idx) => {
      const lat = Number(it.lat);
      const lng = Number(it.lng);
      const key = (isNaN(lat) ? 0 : lat.toFixed(6)) + ',' + (isNaN(lng) ? 0 : lng.toFixed(6));
      (groups[key] = groups[key] || []).push(idx);
    });
    for (const key in groups) {
      const idxs = groups[key];
      if (idxs.length <= 1) continue;
      const baseLat = Number(items[idxs[0]].lat);
      const baseLng = Number(items[idxs[0]].lng);
      const angleStep = (2 * Math.PI) / idxs.length;
      const radius = 0.0003;
      idxs.forEach((idx, k) => {
        const angle = angleStep * k;
        offsets[idx] = {
          lat: baseLat + radius * Math.cos(angle),
          lng: baseLng + radius * Math.sin(angle)
        };
      });
    }
    return offsets;
  }

  // ═══════════════════════════════════════════════════════════════
  // 3. CENTROID MANAGEMENT
  // ═══════════════════════════════════════════════════════════════

  renderCentroidMarkers() {
    this.clearCentroidMarkers();
    if (!this.map || this.zones.length === 0) return;

    for (const z of this.zones) {
      if (z.centroidPos) {
        this.placeCentroidMarker(z, z.centroidPos.lat, z.centroidPos.lng);
      }
    }
  }

  toggleCentroidMode() {
    this.centroidMode = !this.centroidMode;
    if (this.centroidMode) {
      // If no centroids exist yet, auto-generate from zones
      if (!this.zones.some(z => z.centroidPos)) {
        this.autoPlaceCentroids();
      } else {
        this.renderCentroidMarkers();
      }
      this.startMapClickForCentroids();
    } else {
      this.stopMapClickForCentroids();
    }
  }

  startMapClickForCentroids() {
    if (!this.map) return;
    this.centroidMapClickListener = this.map.addListener('click', (event: any) => {
      this.handleMapClickForCentroid(event.latLng);
    });
  }

  stopMapClickForCentroids() {
    if (this.centroidMapClickListener) {
      google.maps.event.removeListener(this.centroidMapClickListener);
      this.centroidMapClickListener = null;
    }
  }

  handleMapClickForCentroid(latLng: any) {
    const nextZone = this.zones.find(z => !z.centroidPos);
    if (!nextZone) {
      this.pnotify.notice({ title: 'Info', text: 'Toutes les zones ont un centre. Réinitialisez pour modifier.', delay: 3000 });
      return;
    }
    this.placeCentroidMarker(nextZone, latLng.lat(), latLng.lng());
  }

  placeCentroidMarker(zone: any, lat: number, lng: number) {
    this.removeCentroidMarkerForZone(zone);
    zone.centroidPos = { lat, lng };

    const marker = new google.maps.Marker({
      position: { lat, lng },
      map: this.map,
      draggable: this.adminStatus,
      icon: {
        path: google.maps.SymbolPath.CIRCLE,
        scale: 14,
        fillColor: zone.busColor || '#337ab7',
        fillOpacity: 0.9,
        strokeWeight: 3,
        strokeColor: '#fff'
      },
      label: { text: zone.zoneName.substring(0, 3), color: '#fff', fontSize: '10px', fontWeight: 'bold' },
      title: zone.zoneName + ' (' + zone.busName + ')',
      zIndex: 200
    });

    const infoWindow = new google.maps.InfoWindow();

    const buildZonePopup = () => {
      const assigned = this.getZonePassengerLoadCount(zone.zoneId);
      const available = zone.capacity - assigned;
      const availColor = available >= 0 ? '#27ae60' : '#e74c3c';
      return `<div class="passenger-popup">
        <div class="pw-header">
          <span class="pw-name" style="color:${zone.busColor || '#337ab7'}">${zone.zoneName}</span>
        </div>
        <div class="pw-body">
          <div class="pw-row"><span class="pw-label">Bus</span><span class="pw-value">${zone.busName}</span></div>
          <div class="pw-row"><span class="pw-label">Chauffeur</span><span class="pw-value">${zone.driverName}</span></div>
          <div class="pw-row"><span class="pw-label">Capacité</span><span class="pw-value">${zone.capacity}</span></div>
          <div class="pw-row"><span class="pw-label">Affectés</span><span class="pw-value">${assigned}</span></div>
          <div class="pw-row"><span class="pw-label">Disponible</span><span class="pw-value" style="color:${availColor}">${available >= 0 ? available : 0}</span></div>
        </div>
      </div>`;
    };

    marker.addListener('mouseover', () => {
      infoWindow.setContent(buildZonePopup());
      infoWindow.open(this.map, marker);
    });
    marker.addListener('mouseout', () => {
      if (!(marker as any)._popupPinned) {
        infoWindow.close();
      }
    });
    marker.addListener('click', () => {
      if ((marker as any)._popupPinned) {
        (marker as any)._popupPinned = false;
        infoWindow.close();
      } else {
        // Clear any previously pinned centroid marker
        for (const cm of this.centroidMarkers) {
          (cm.marker as any)._popupPinned = false;
        }
        (marker as any)._popupPinned = true;
        infoWindow.setContent(buildZonePopup());
        infoWindow.open(this.map, marker);
      }
    });
    marker.addListener('dragend', (event: any) => {
      zone.centroidPos = { lat: event.latLng.lat(), lng: event.latLng.lng() };
      this.hasLocalChanges = true;
    });

    this.centroidMarkers.push({ zoneId: zone.zoneId, marker });
  }

  removeCentroidMarkerForZone(zone: any) {
    const idx = this.centroidMarkers.findIndex(m => m.zoneId === zone.zoneId);
    if (idx >= 0) {
      this.centroidMarkers[idx].marker.setMap(null);
      this.centroidMarkers.splice(idx, 1);
    }
  }

  clearCentroidMarkers() {
    for (const item of this.centroidMarkers) { item.marker.setMap(null); }
    this.centroidMarkers = [];
  }

  autoPlaceCentroids() {
    this.clearCentroidMarkers();
    // Clear existing centroid positions so they get recomputed
    for (const z of this.zones) { z.centroidPos = null; }
    if (this.zones.length === 0) return;

    const k = this.zones.length;
    const points = this.passengers.filter(p => p.lat && p.lng);

    if (points.length === 0) return;

    // Farthest point selection (same as PHP balancedKMeansClustering init)
    const selectedPositions: { lat: number; lng: number }[] = [];
    const usedIndices: { [idx: number]: boolean } = {};

    // First centroid: pick the parent farthest from school (or random if no school)
    let firstIdx = 0;
    if (this.school && this.school.lat && this.school.lng) {
      let maxDist = -1;
      const sLat = Number(this.school.lat);
      const sLng = Number(this.school.lng);
      for (let i = 0; i < points.length; i++) {
        const dist = Math.pow(points[i].lat - sLat, 2) + Math.pow(points[i].lng - sLng, 2);
        if (dist > maxDist) { maxDist = dist; firstIdx = i; }
      }
    } else {
      firstIdx = Math.floor(Math.random() * points.length);
    }
    selectedPositions.push({ lat: points[firstIdx].lat, lng: points[firstIdx].lng });
    usedIndices[firstIdx] = true;

    // Remaining centroids: pick parent farthest from all existing centroids
    for (let c = 1; c < k; c++) {
      let maxMinDist = -1;
      let bestIdx = 0;

      for (let i = 0; i < points.length; i++) {
        if (usedIndices[i]) continue;
        let minDist = Infinity;
        for (const centroid of selectedPositions) {
          const dist = Math.pow(points[i].lat - centroid.lat, 2) + Math.pow(points[i].lng - centroid.lng, 2);
          if (dist < minDist) minDist = dist;
        }
        if (minDist > maxMinDist) {
          maxMinDist = minDist;
          bestIdx = i;
        }
      }

      selectedPositions.push({ lat: points[bestIdx].lat, lng: points[bestIdx].lng });
      usedIndices[bestIdx] = true;
    }

    // Place centroid markers at selected positions
    for (let i = 0; i < this.zones.length; i++) {
      this.placeCentroidMarker(this.zones[i], selectedPositions[i].lat, selectedPositions[i].lng);
    }
  }

  resetCentroids() {
    this.clearCentroidMarkers();
    for (const z of this.zones) {
      z.centroidPos = z.centroidPos_original ? { lat: z.centroidPos_original.lat, lng: z.centroidPos_original.lng } : null;
    }
    // Re-render with DB positions (or auto-place if none existed in DB)
    if (this.zones.some(z => z.centroidPos)) {
      this.renderCentroidMarkers();
    } else {
      this.autoPlaceCentroids();
    }
  }

  hasCentroidsConfigured(): boolean {
    return this.zones.some(z => z.centroidPos);
  }

  countConfiguredCentroids(): number {
    return this.zones.filter(z => z.centroidPos).length;
  }

  getCentroidsForBackend(): any {
    const map: any = {};
    for (const z of this.zones) {
      if (z.centroidPos) {
        map[z.zoneId] = { lat: z.centroidPos.lat, lng: z.centroidPos.lng };
      }
    }
    return map;
  }

  // ═══════════════════════════════════════════════════════════════
  // 4. ACTIONS: RECREATE / ADAPT / MANUAL
  // ═══════════════════════════════════════════════════════════════

  /** Open centered confirmation modal */
  openConfirmDialog(title: string, message: string, icon: string, btnText: string, btnClass: string, action: () => void) {
    this.confirmTitle = title;
    this.confirmMessage = message;
    this.confirmIcon = icon;
    this.confirmBtnText = btnText;
    this.confirmBtnClass = btnClass;
    this.confirmAction = action;
    this.showConfirmModal = true;
  }

  executeConfirm() {
    this.showConfirmModal = false;
    if (this.confirmAction) { this.confirmAction(); }
  }

  /** Start Recreate Zones mode */
  startRecreateZones() {
    this.openConfirmDialog(
      'Recréer les zones',
      'Voulez-vous recréer toutes les zones ? Les affectations actuelles seront remplacées.',
      'fa fa-refresh',
      'Oui, recréer',
      'btn btn-warning',
      () => {
        this.actionMode = 'recreate';
        this.automationResult = null;
        if (!this.hasCentroidsConfigured()) { this.autoPlaceCentroids(); }
        this.simulateDistribution('recreate');
      }
    );
  }

  /** Start Adapt Zones mode */
  startAdaptZones() {
    this.openConfirmDialog(
      'Adapter les zones',
      'Voulez-vous adapter les zones ? Seuls les parents non affectés seront redistribués.',
      'fa fa-plus-circle',
      'Oui, adapter',
      'btn btn-info',
      () => {
        this.actionMode = 'adapt';
        this.automationResult = null;
        if (!this.hasCentroidsConfigured()) { this.autoPlaceCentroids(); }
        this.simulateDistribution('adapt');
      }
    );
  }

  /** Toggle Manual Assignment mode */
  startManualMode() {
    if (this.actionMode === 'manual') {
      this.actionMode = 'none';
      this.manualAssignZoneId = null;
      this.manualDeaffectMode = false;
    } else {
      this.actionMode = 'manual';
      this.manualAssignZoneId = null;
      this.manualDeaffectMode = false;
    }
  }

  /** Cancel all changes and revert to DB state */
  cancelAllChanges() {
    for (const p of this.passengers) {
      p.zoneId = p.zoneId_original;
      p.busId = p.busId_original;
    }
    // Restore centroid positions to original
    for (const z of this.zones) {
      z.centroidPos = z.centroidPos_original ? { lat: z.centroidPos_original.lat, lng: z.centroidPos_original.lng } : null;
      const cm = this.centroidMarkers.find(m => m.zoneId === z.zoneId);
      if (cm && z.centroidPos) {
        cm.marker.setPosition({ lat: z.centroidPos.lat, lng: z.centroidPos.lng });
      }
    }
    this.actionMode = 'none';
    this.automationResult = null;
    this.hasLocalChanges = false;
    this.manualDeaffectMode = false;
    this.renderParentMarkers();
  }

  /** Call backend to simulate distribution */
  simulateDistribution(mode: 'recreate' | 'adapt') {
    this.automationLoading = true;
    const centroidsPayload = this.getCentroidsForBackend();
    console.log('[ZONE_DEBUG_FE] === simulateDistribution ===');
    console.log('[ZONE_DEBUG_FE] mode:', mode);
    console.log('[ZONE_DEBUG_FE] this.zones order:');
    this.zones.forEach((z, i) => {
      console.log(`[ZONE_DEBUG_FE]   zone[${i}]: zoneId=${z.zoneId} busId=${z.busId} busName="${z.busName}" zoneName="${z.zoneName}" centroidPos=${JSON.stringify(z.centroidPos)}`);
    });
    console.log('[ZONE_DEBUG_FE] centroids sent:', JSON.stringify(centroidsPayload));

    this.http.post('/api/automation/zones/preview', {
      schoolId: this.filter.schoolId,
      centroids: centroidsPayload,
      mode: mode
    }).subscribe(
      (result: any) => {
        console.log('[ZONE_DEBUG_FE] backend response zones:');
        if (result.zones) {
          result.zones.forEach((pz, i) => {
            console.log(`[ZONE_DEBUG_FE]   resp[${i}]: zone_id=${pz.zone_id} bus_name="${pz.bus_name}" parent_count=${pz.parent_count} centroid=${JSON.stringify(pz.centroid)}`);
          });
        }
        this.automationResult = result;
        this.automationLoading = false;
        if (result.success && result.zones) {
          this.applyPreviewToLocal(result.zones);
        }
      },
      (error) => {
        this.automationResult = { success: false, error: error.error ? error.error.error : 'Erreur serveur' };
        this.automationLoading = false;
      }
    );
  }

  /** Apply preview result to local passengers (no DB write) */
  applyPreviewToLocal(previewZones: any[]) {
    // Reset all passenger zones
    for (const p of this.passengers) {
      p.zoneId = null;
      p.busId = null;
    }
    // Assign based on preview
    for (const pz of previewZones) {
      for (const pid of (pz.parent_ids || [])) {
        const passenger = this.passengers.find(pa => pa.id === pid);
        if (passenger) {
          passenger.zoneId = pz.zone_id;
          passenger.busId = pz.bus_id;
        }
      }

      // Update centroid markers to match recomputed positions
      if (pz.centroid && pz.centroid.lat !== undefined) {
        const zone = this.zones.find(z => z.zoneId === pz.zone_id);
        if (zone) {
          zone.centroidPos = { lat: pz.centroid.lat, lng: pz.centroid.lng };
          const cm = this.centroidMarkers.find(m => m.zoneId === pz.zone_id);
          if (cm) {
            cm.marker.setPosition(new google.maps.LatLng(pz.centroid.lat, pz.centroid.lng));
          } else if (this.map) {
            // Create marker if it doesn't exist yet
            this.placeCentroidMarker(zone, pz.centroid.lat, pz.centroid.lng);
          }
        }
      }
    }
    this.hasLocalChanges = true;
    this.renderParentMarkers();
  }

  /** Manual assignment: click on parent to assign to selected zone or deaffect */
  handleManualAssignment(passenger: any, marker?: any) {
    const oldZoneId = passenger.zoneId;

    // Deaffect mode
    if (this.manualDeaffectMode) {
      passenger.zoneId = null;
      passenger.busId = null;
      this.hasLocalChanges = true;
      this.updateMarkerIcon(marker, null);
      if (oldZoneId) this.recomputeZoneCentroid(oldZoneId);
      return;
    }

    // Assign mode
    if (!this.manualAssignZoneId) {
      this.pnotify.notice({ title: 'Info', text: 'Sélectionnez une zone cible ou "Désaffecter".', delay: 2500 });
      return;
    }
    const targetZone = this.zones.find(z => z.zoneId === this.manualAssignZoneId);
    if (!targetZone) return;

    // Check capacity: warn but still allow assignment (school works progressively)
    const currentCount = this.getZonePassengerLoadCount(targetZone.zoneId);
    if (currentCount >= targetZone.capacity) {
      this.pnotify.notice({ title: 'Capacité dépassée', text: `La zone ${targetZone.zoneName} a atteint sa capacité (${targetZone.capacity} max).`, delay: 3000 });
    }

    passenger.zoneId = targetZone.zoneId;
    passenger.busId = targetZone.busId;
    this.hasLocalChanges = true;
    this.updateMarkerIcon(marker, targetZone);

    // Recompute centroids for both affected zones
    if (oldZoneId && oldZoneId !== targetZone.zoneId) this.recomputeZoneCentroid(oldZoneId);
    this.recomputeZoneCentroid(targetZone.zoneId);
  }

  /** Update a single marker icon to reflect zone assignment without re-rendering all markers */
  updateMarkerIcon(marker: any, zone: any) {
    if (!marker) return;
    if (zone) {
      marker.setIcon({
        path: this.ZONE_LEVEL_SHAPES[zone.zoneLevel % this.ZONE_LEVEL_SHAPES.length],
        scale: 8,
        fillColor: zone.busColor || '#337ab7',
        fillOpacity: 1,
        strokeWeight: 2,
        strokeColor: '#fff'
      });
    } else {
      marker.setIcon({
        path: this.UNASSIGNED_SHAPE,
        scale: 8,
        fillColor: '#999',
        fillOpacity: 1,
        strokeWeight: 2,
        strokeColor: '#999'
      });
    }
  }

  /** Recompute centroid for a zone as average of its assigned parents, update map marker */
  recomputeZoneCentroid(zoneId: number) {
    const zone = this.zones.find(z => z.zoneId === zoneId);
    if (!zone) return;
    const zoneParents = this.passengers.filter(p => p.zoneId === zoneId);
    if (zoneParents.length === 0) {
      zone.centroidPos = null;
    } else {
      const sumLat = zoneParents.reduce((s, p) => s + p.lat, 0);
      const sumLng = zoneParents.reduce((s, p) => s + p.lng, 0);
      zone.centroidPos = { lat: sumLat / zoneParents.length, lng: sumLng / zoneParents.length };
    }
    // Update centroid marker on map
    const cm = this.centroidMarkers.find(m => m.zoneId === zoneId);
    if (cm) {
      if (zone.centroidPos) {
        cm.marker.setPosition(new google.maps.LatLng(zone.centroidPos.lat, zone.centroidPos.lng));
      } else {
        cm.marker.setMap(null);
        this.centroidMarkers = this.centroidMarkers.filter(m => m.zoneId !== zoneId);
      }
    }
  }

  selectManualZone(zoneId: number) {
    this.manualAssignZoneId = zoneId;
    this.manualDeaffectMode = false;
  }

  selectDeaffectMode() {
    this.manualDeaffectMode = true;
    this.manualAssignZoneId = null;
  }

  // ═══════════════════════════════════════════════════════════════
  // 5. CONFIRM (SAVE TO DB)
  // ═══════════════════════════════════════════════════════════════

  confirmChanges() {
    if (this.hasOverflow) {
      this.openConfirmDialog(
        'Capacité dépassée',
        'Une ou plusieurs zones dépassent la capacité du bus. Voulez-vous quand même confirmer et sauvegarder ?',
        'fa fa-exclamation-triangle',
        'Oui, confirmer',
        'btn btn-warning',
        () => { this.doConfirmChanges(); }
      );
    } else {
      this.doConfirmChanges();
    }
  }

  doConfirmChanges() {
    this.automationLoading = true;

    const zonesPayload = this.zones.map(z => ({
      zone_id: z.zoneId,
      bus_id: z.busId,
      bus_name: z.busName,
      parent_ids: this.passengers.filter(p => p.zoneId === z.zoneId).map(p => p.id),
      capacity: z.capacity,
      centroid: z.centroidPos ? { lat: z.centroidPos.lat, lng: z.centroidPos.lng } : null
    }));

    // Collect deaffected passenger IDs (no zone, no bus)
    const deaffectedIds = this.passengers.filter(p => !p.zoneId && !p.busId).map(p => p.id);

    this.http.post('/api/automation/zones/confirm', {
      schoolId: this.filter.schoolId,
      zones: zonesPayload,
      centroids: this.getCentroidsForBackend(),
      deaffected_ids: deaffectedIds
    }).subscribe(
      (result: any) => {
        this.automationLoading = false;
        if (result.success) {
          this.pnotify.success({ title: 'Confirmé', text: result.message, delay: 4000 });
          // Update originals
          for (const p of this.passengers) {
            p.zoneId_original = p.zoneId;
            p.busId_original = p.busId;
          }
          for (const z of this.zones) {
            z.centroidPos_original = z.centroidPos ? { lat: z.centroidPos.lat, lng: z.centroidPos.lng } : null;
          }
          this.hasLocalChanges = false;
          this.actionMode = 'none';
          this.automationResult = null;
        } else {
          this.pnotify.error({ title: 'Erreur', text: result.error || 'Erreur inconnue', delay: 4000 });
        }
      },
      (error) => {
        this.automationLoading = false;
        this.pnotify.error({ title: 'Erreur', text: 'Erreur serveur lors de la confirmation.', delay: 4000 });
      }
    );
  }

  // ═══════════════════════════════════════════════════════════════
  // 6. HELPERS
  // ═══════════════════════════════════════════════════════════════

  getZonePassengerCount(zoneId: number): number {
    return this.passengers.filter(p => p.zoneId === zoneId).length;
  }

  getZonePassengerLoadCount(zoneId: number): number {
    return this.passengers.filter(p => p.zoneId === zoneId).reduce((sum, p) => sum + p.count, 0);
  }

  getTotalPassengers(): number {
    return this.passengers.length + this.passengersWithoutPositionCount;
  }

  getTotalCapacity(): number {
    return this.zones.reduce((sum, z) => sum + z.capacity, 0);
  }

  getUnassignedLoadCount(): number {
    return this.passengers.filter(p => !p.zoneId).reduce((sum, p) => sum + p.count, 0);
  }

  getTotalPassengerLoad(): number {
    return this.passengers.reduce((sum, p) => sum + p.count, 0);
  }

  getUnassignedCount(): number {
    return this.passengers.filter(p => !p.zoneId).length;
  }

  getAssistantCount(): number {
    return this.passengers.filter(p => p.isAssistant).length;
  }

  get hasCentroidChanges(): boolean {
    return this.zones.some(z => {
      const orig = z.centroidPos_original;
      const curr = z.centroidPos;
      if (!orig && !curr) return false;
      if (!orig || !curr) return true;
      return orig.lat !== curr.lat || orig.lng !== curr.lng;
    });
  }

  get hasOverflow(): boolean {
    return this.zones.some(z => this.getZonePassengerLoadCount(z.zoneId) > z.capacity);
  }

  getZoneLevel(zoneId: number): number {
    const zone = this.zones.find(z => z.zoneId === zoneId);
    return zone ? zone.zoneLevel : 0;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/subscription/subscription-zones-distribution/subscription-zones-distribution.component.ts